import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="export-filter"
export default class extends Controller {
  static targets = ["item", "allCount", "csvCount", "powerpointCount", "emptyState"]

  connect() {
    this.updateCounts()
  }

  filter(event) {
    event.preventDefault()

    // Don't process if clicking on badge or already active
    const link = event.target.closest('a')
    if (!link) return

    const filterType = link.dataset.filter

    // Update active tab
    this.element.querySelectorAll('.nav-link').forEach(navLink => {
      navLink.classList.remove('active')
    })
    link.classList.add('active')

    // Filter items
    let visibleCount = 0
    this.itemTargets.forEach(item => {
      const exportType = item.dataset.exportType

      if (filterType === 'all' || exportType === filterType) {
        item.style.display = ''
        visibleCount++
      } else {
        item.style.display = 'none'
      }
    })

    // Show/hide empty state based on visible items
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.style.display = visibleCount === 0 ? '' : 'none'
    }
  }

  updateCounts() {
    // Count all items
    const allCount = this.itemTargets.length
    const csvCount = this.itemTargets.filter(item => item.dataset.exportType === 'csv').length
    const powerpointCount = this.itemTargets.filter(item => item.dataset.exportType === 'powerpoint').length

    // Update badges
    if (this.hasAllCountTarget) this.allCountTarget.textContent = allCount
    if (this.hasCsvCountTarget) this.csvCountTarget.textContent = csvCount
    if (this.hasPowerpointCountTarget) this.powerpointCountTarget.textContent = powerpointCount

    // Update empty state visibility
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.style.display = allCount === 0 ? '' : 'none'
    }
  }

  // Called when items are added/removed via Turbo Stream
  itemTargetConnected() {
    this.updateCounts()
  }

  itemTargetDisconnected() {
    this.updateCounts()
  }
}
